package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.icons.Icon
import com.arena_web.ui.theme.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import org.jetbrains.compose.web.css.*

@Composable
fun BusinessBottomNavBar(activeTab: BusinessSidebarTab? = null) {
    val ctx = rememberPageContext()
    val sportColors = LocalSportColors.current

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .position(Position.Fixed)
            .bottom(24.px)
            .left(0.px)
            .right(0.px)
            .zIndex(1000),
        contentAlignment = Alignment.Center
    ) {
        Row(
            modifier = Modifier
                .borderRadius(150.px)
                .padding(6.px)
                .gap(8.px)
                .styleModifier {
                    property("border", "0.8px solid rgba(255, 255, 255, 0.4)")
                    property(
                        "background",
                        AppGradients.InteractiveSecondary
                    )
                    property("backdrop-filter", "blur(20px)")
                    property("-webkit-backdrop-filter", "blur(20px)")
                },
            verticalAlignment = Alignment.CenterVertically
        ) {
            BusinessSidebarTab.entries.forEach { tab ->
                val isActive = tab == activeTab

                Box(
                    modifier = Modifier
                        .size(52.px)
                        .borderRadius(100.px)
                        .cursor(Cursor.Pointer)
                        .then(
                            if (isActive) Modifier
                                .backgroundColor(sportColors.primary)
                                .styleModifier {
                                    property("border", "0.3px solid var(--arena-border-top)")
                                }
                            else Modifier
                        )
                        .onClick { ctx.router.navigateTo(tab.route) },
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        src = tab.icon,
                        modifier = Modifier
                            .size(22.px)
                            .then(
                                if (isActive) Modifier.styleModifier {
                                    property("filter", sportColors.iconFilterOnPrimary)
                                }
                                else Modifier.opacity(0.5f)
                            )
                    )
                }
            }
        }
    }
}
